import { generate } from "@pdfme/generator";
import CoolvelticaRegular from "../../../assets/fonts/Coolvetica/coolvetica_rg.ttf"
import CoolveticaCondensed from "../../../assets/fonts/Coolvetica/coolvetica_condensed_rg.ttf";
import Raleway from  "../../../assets/fonts/Raleway/Raleway-Medium.ttf";
import { ARTICLE_BOX_IMG, BASE_PDF, COMMENT_BOX_IMG, LINE_BREAK, LINE_HEIGHT, LINE_LENGTH, LJD_BORDER_DISTANCE, MESSAGE_ICON, PAGE_CONTENT_START, PAGE_LIMIT, TEXT_TOP_START } from "../constants";

export const generatePDF = async ({ title, article, article_text, text, legislative, jurisprudence, doctrinal, comments }) => {
  let currentTextTop = TEXT_TOP_START
  let currentPage = 1
  
  const cleanTitle = title.split('<br />').map(line => line.trim()).join("\n").toUpperCase()
  const formattedTitle = cleanTitle.split("\n").map(line => {
    if(line.trim().length > 28){
      let count = 0;
      let i = 0;

      return line.split(" ").map(word => {
        if(word.trim().length + count + i >= 27) {
          count = word.trim().length;
          i = 1;
          return "\n" + word;
        }
        count += word.trim().length;
        i++;
        return word;
      }).join(" ");
    }
    return line;
  }).join("\n");
  const splitedTitle = formattedTitle.split("\n");

  const textSplitted = text.split('<br />').map(paragraph => paragraph.trim())
  const textFiltered = textSplitted.filter(paragraph => paragraph !== "").map(paragraph => paragraph.split('\n').join(''))
  const legislativeSplitted = legislative.includes('<li>') ? legislative.split('</li>') : legislative.split('</p>')
  const legislativeFiltered = legislative.includes('<li>') ?
    legislativeSplitted.map(paragraph => paragraph.split('<li>').map(line => line.trim()).join('').split('</li>').join('').split('<ul>').join('').split('</ul>').join('')).filter(paragraph => paragraph !== "")
    :
    legislativeSplitted.map(paragraph => paragraph.split('<p>').map(line => line.trim()).join('').split('</p>').join('')).filter(paragraph => paragraph !== "")
  
  const jurisprudenceSplitted = jurisprudence.includes('<li>') ? jurisprudence.split('</li>') : jurisprudence.split('</p>')
  const jurisprudenceFiltered = jurisprudence.includes('<li>') ?
    jurisprudenceSplitted.map(paragraph => paragraph.split('<li>').map(line => line.trim()).join('').split('</li>').join('').split('<ul>').join('').split('</ul>').join('')).filter(paragraph => paragraph !== "")
    :
    jurisprudenceSplitted.map(paragraph => paragraph.split('<p>').map(line => line.trim()).join('').split('</p>').join('')).filter(paragraph => paragraph !== "")

  const doctrinalSplitted = doctrinal.includes('<li>') ? doctrinal.split('</li>') : doctrinal.split('</p>')
  const doctrinalFiltered = doctrinal.includes('<li>') ?
    doctrinalSplitted.map(paragraph => paragraph.split('<li>').map(line => line.trim()).join('').split('</li>').join('').split('<ul>').join('').split('</ul>').join('')).filter(paragraph => paragraph !== "")
    :
    doctrinalSplitted.map(paragraph => paragraph.split('<p>').map(line => line.trim()).join('').split('</p>').join('')).filter(paragraph => paragraph !== "")

  const font = {
    coolveltica: {
      data: await fetch(CoolvelticaRegular).then((res) => res.arrayBuffer()),
      fallback: true,
    },
    coolveltica_condensed: {
      data: await fetch(CoolveticaCondensed).then((res) => res.arrayBuffer()),
    },
    raleway: {
      data: await fetch(Raleway).then((res) => res.arrayBuffer()),
    }
  }

  const template = {
    "schemas": [{
      "document_title": {
        "type": "text",
        "position": {
          "x": 30,
          "y": PAGE_CONTENT_START
        },
        "width": 68,
        "height": 14,
        "fontSize": 24,
        "fontColor": "#102069",
        "fontName": "coolveltica",
        "backgroundColor": "#ef8303",
        "alignment": "center",
        "lineHeight": 1.4
      },
      "article_box": {
        "type": "image",
        "position": {
          "x": 22,
          "y": 38.5
        },
        "width": 160,
        "height": 14.5
      },
      "article_title": {
        "type": "text",
        "position": {
          "x": 106,
          "y": 14
        },
        "width": 80,
        "height": 16,
        "alignment": "left",
        "fontSize": 24,
        "characterSpacing": 0,
        "lineHeight": 1.1,
        "fontName": "coolveltica_condensed",
        "fontColor": "#102069"
      },
      "article_number": {
        "type": "text",
        "position": {
          "x": 23,
          "y": 39.5
        },
        "width": 35,
        "height": 10,
        "fontSize": 26,
        "fontColor": "#102069",
        "fontName": "coolveltica",
      },
      "article_consideration": {
        "type": "text",
        "position": {
          "x": 60,
          "y": 39.5
        },
        "width": 129,
        "height": 3,
        "alignment": "left",
        "fontSize": 13,
        "characterSpacing": 0,
        "lineHeight": 1,
        "fontName": "coolveltica",
        "fontColor": "#102060"
      },
      "reference_title": {
        "type": "text",
        "position": {
          "x": 72,
        },
        "width": 60,
        "height": 12,
        "fontSize": 20,
        "fontColor": "#102069",
        "fontName": "coolveltica",
        "backgroundColor": "#ef8303",
        "alignment": "center",
        "lineHeight": 1.4
      },
      "legislative_title": {
        "type": "text",
        "position": {
          "x": 24,
        },
        "width": 60,
        "height": 12,
        "fontSize": 22,
        "fontColor": "#102069",
        "fontName": "coolveltica",
        "lineHeight": 1.4
      },
      "legislative_border": {
        "type": "text",
        "position": {
          "x": 65,
        },
        "width": 118,
        "height": 0.5,
        "fontColor": "#ffffff",
        "fontName": "coolveltica",
        "backgroundColor": "#102069",
        "lineHeight": 0.1
      },
      "jurisprudence_title": {
        "type": "text",
        "position": {
          "x": 24,
        },
        "width": 60,
        "height": 12,
        "fontSize": 22,
        "fontColor": "#102069",
        "fontName": "coolveltica",
        "lineHeight": 1.4
      },
      "jurisprudence_border": {
        "type": "text",
        "position": {
          "x": 79,
        },
        "width": 104,
        "height": 0.5,
        "fontColor": "#ffffff",
        "fontName": "coolveltica",
        "backgroundColor": "#102069",
        "lineHeight": 0.1
      },
      "doctrinal_title": {
        "type": "text",
        "position": {
          "x": 24,
        },
        "width": 60,
        "height": 12,
        "fontSize": 22,
        "fontColor": "#102069",
        "fontName": "coolveltica",
        "lineHeight": 1.4
      },
      "doctrinal_border": {
        "type": "text",
        "position": {
          "x": 65,
        },
        "width": 118,
        "height": 0.5,
        "fontColor": "#ffffff",
        "fontName": "coolveltica",
        "backgroundColor": "#102069",
        "lineHeight": 0.1
      },
    }],
    "basePdf": BASE_PDF
  };

  const inputs = [
    {
      "document_title": "LDA Comentada",
      "article_box": ARTICLE_BOX_IMG,
      "article_title": formattedTitle,
      "article_number": `Art. ${article}`,
      "article_consideration": `${article_text}`,
    }
  ];
// Para o exercício e defesa de seus direitos, podem os autores e os
  if(splitedTitle.length > 2) {
    const line = 9.6 * (splitedTitle.length - 2);
    currentTextTop += line

    template.schemas[0].article_box.position = {
      x: template.schemas[0].article_box.position.x,
      y: template.schemas[0].article_box.position.y + line
    }

    template.schemas[0].article_number.position = {
      x: template.schemas[0].article_number.position.x,
      y: template.schemas[0].article_number.position.y + line
    }
    template.schemas[0].article_consideration.position = {
      x: template.schemas[0].article_consideration.position.x,
      y: template.schemas[0].article_consideration.position.y + line
    }
  }

  let article_text_lines = Math.ceil(article_text.length/58);
  if(article_text_lines > 2) {
    let count = 0;
    let i = 0;
    let article_text_breaked = article_text.split(" ").map(word => {
      if(word.length + count + i >= 64) {
        count = word.length;
        i = 1;
        return "\n" + word;
      }
      count += word.length;
      i++;
      return word;
    }).join(" ");

    inputs[0].article_consideration = article_text_breaked;
    article_text_lines = article_text_breaked.split("\n").length;
    currentTextTop += article_text_lines*2;
    template.schemas[0].article_box.width *= 1.05;
    //if(article_text_lines <= 9) {
    template.schemas[0].article_box.height = (article_text_lines*3.6) + 14.5;
    //} else {
      //template.schemas[0].article_box.height = 0;
    //}
  }

  //Mediante contrato de edição, o editor, obrigando-se a reproduzir e
// a divulgar a obra literária, artística ou científica, fica autorizado, e

splitedTitle.map((line, index) => {
  if(line && line.trim().length) {
    inputs[0][`art_line_${index}`] = '.';
    template.schemas[0][`art_line_${index}`] = {
      "type": "text",
      "position": {
        "x": 106.3,
        "y": 24 + (9.6 * index)
      },
      "width": ((line.trim().length*0.6) *4.6) - (index? 3 : 5),
      //"width": line?.trim().length * 2.67,
      "height": 0.7,
      "alignment": "left",
      "fontSize": 24,
      "characterSpacing": 0,
      "lineHeight": 1.3,
      "fontName": "coolveltica_condensed",
      "backgroundColor": "#102069",
      "fontColor": "#fff"
    }
  }
});

  // eslint-disable-next-line array-callback-return
  textFiltered.map((paragraph, index) => {
    const lines = Math.ceil(paragraph.length / LINE_LENGTH)
    const height = lines * LINE_HEIGHT
    const schema = {}
    const input = {}

    if (currentTextTop > PAGE_LIMIT) {
      currentPage += 1
      currentTextTop = 20
    }

    schema[`article_text_${index}`] = {
      "type": "text",
      "position": {
        "x": 24,
        "y": currentTextTop,
      },
      "width": 160,
      "height": height,
      "fontSize": 10,
      "fontName": "raleway",
      "lineHeight": 1.4,
    }

    currentTextTop += height + LINE_BREAK

    if (paragraph.includes('<strong>')) {
      schema[`article_text_${index}`].fontColor = '#fff'
      schema[`article_text_${index}`].backgroundColor = '#102069'
      input[`article_text_${index}`] = paragraph.split('<strong>').join('').split('</strong>').join('').trim()
    } else {
      schema[`article_text_${index}`].fontColor = '#102069'
      input[`article_text_${index}`] = paragraph.trim()
    }
    
    if (inputs.length < currentPage) {
      inputs.push({})
    }

    for (let key in schema) {
      template.schemas[0][key] = schema[key]
    }

    for (let key in input) {
      inputs[currentPage - 1][key] = input[key]
    }
  })

  inputs.push({})
  currentPage += 1
  currentTextTop = 20

  template.schemas[0]['reference_title'].position.y = currentTextTop
  inputs[currentPage - 1]['reference_title'] = "Referências"
  currentTextTop += 16

  template.schemas[0]['legislative_title'].position.y = currentTextTop
  template.schemas[0]['legislative_border'].position.y = currentTextTop + LJD_BORDER_DISTANCE
  inputs[currentPage - 1]['legislative_title'] = "Legislativas"
  inputs[currentPage - 1]['legislative_border'] = "."
  currentTextTop += 12

  // eslint-disable-next-line array-callback-return
  legislativeFiltered.map((paragraph, index) => {
    const lines = Math.ceil(paragraph.length / LINE_LENGTH)
    const height = lines * LINE_HEIGHT
    const schema = {}
    const input = {}

    if (currentTextTop > PAGE_LIMIT) {
      currentPage += 1
      currentTextTop = 20
    }

    schema[`legislative_text_${index}`] = {
      "type": "text",
      "position": {
        "x": 24,
        "y": currentTextTop,
      },
      "width": 160,
      "height": height,
      "fontSize": 10,
      "fontName": "raleway",
      "lineHeight": 1.4,
    }

    currentTextTop += height + LINE_BREAK / 2

    if (paragraph.includes('<strong>')) {
      schema[`legislative_text_${index}`].fontColor = '#fff'
      schema[`legislative_text_${index}`].backgroundColor = '#102069'
      input[`legislative_text_${index}`] = paragraph.split('<strong>').join('').split('</strong>').join('').trim()
    } else {
      schema[`legislative_text_${index}`].fontColor = '#102069'
      input[`legislative_text_${index}`] = paragraph.trim()
    }
    
    if (inputs.length < currentPage) {
      inputs.push({})
    }

    for (let key in schema) {
      template.schemas[0][key] = schema[key]
    }

    for (let key in input) {
      inputs[currentPage - 1][key] = input[key]
    }
  })

  template.schemas[0]['jurisprudence_title'].position.y = currentTextTop
  template.schemas[0]['jurisprudence_border'].position.y = currentTextTop + LJD_BORDER_DISTANCE
  inputs[currentPage - 1]['jurisprudence_title'] = "Jurisprudenciais"
  inputs[currentPage - 1]['jurisprudence_border'] = "."
  currentTextTop += 12

  // eslint-disable-next-line array-callback-return
  jurisprudenceFiltered.map((paragraph, index) => {
    const lines = Math.ceil(paragraph.length / LINE_LENGTH)
    const height = lines * LINE_HEIGHT
    const schema = {}
    const input = {}

    if (currentTextTop > PAGE_LIMIT) {
      currentPage += 1
      currentTextTop = 20
    }

    schema[`jurisprudence_text_${index}`] = {
      "type": "text",
      "position": {
        "x": 24,
        "y": currentTextTop,
      },
      "width": 160,
      "height": height,
      "fontSize": 10,
      "fontName": "raleway",
      "lineHeight": 1.4,
    }

    currentTextTop += height + LINE_BREAK / 2

    if (paragraph.includes('<strong>')) {
      schema[`jurisprudence_text_${index}`].fontColor = '#fff'
      schema[`jurisprudence_text_${index}`].backgroundColor = '#102069'
      input[`jurisprudence_text_${index}`] = paragraph.split('<strong>').join('').split('</strong>').join('').trim()
    } else {
      schema[`jurisprudence_text_${index}`].fontColor = '#102069'
      input[`jurisprudence_text_${index}`] = paragraph.trim()
    }
    
    if (inputs.length < currentPage) {
      inputs.push({})
    }

    for (let key in schema) {
      template.schemas[0][key] = schema[key]
    }

    for (let key in input) {
      inputs[currentPage - 1][key] = input[key]
    }
  })
  
  template.schemas[0]['doctrinal_title'].position.y = currentTextTop
  template.schemas[0]['doctrinal_border'].position.y = currentTextTop + LJD_BORDER_DISTANCE
  inputs[currentPage - 1]['doctrinal_title'] = "Doutrinárias"
  inputs[currentPage - 1]['doctrinal_border'] = "."
  currentTextTop += 12

  // eslint-disable-next-line array-callback-return
  doctrinalFiltered.map((paragraph, index) => {
    const lines = Math.ceil(paragraph.length / LINE_LENGTH)
    const height = lines * LINE_HEIGHT
    const schema = {}
    const input = {}

    if (currentTextTop > PAGE_LIMIT) {
      currentPage += 1
      currentTextTop = 20
    }

    schema[`doctrinal_text_${index}`] = {
      "type": "text",
      "position": {
        "x": 24,
        "y": currentTextTop,
      },
      "width": 160,
      "height": height,
      "fontSize": 10,
      "fontName": "raleway",
      "lineHeight": 1.4,
    }

    currentTextTop += height + LINE_BREAK / 2

    if (paragraph.includes('<strong>')) {
      schema[`doctrinal_text_${index}`].fontColor = '#fff'
      schema[`doctrinal_text_${index}`].backgroundColor = '#102069'
      input[`doctrinal_text_${index}`] = paragraph.split('<strong>').join('').split('</strong>').join('').trim()
    } else {
      schema[`doctrinal_text_${index}`].fontColor = '#102069'
      input[`doctrinal_text_${index}`] = paragraph.trim()
    }
    
    if (inputs.length < currentPage) {
      inputs.push({})
    }

    for (let key in schema) {
      template.schemas[0][key] = schema[key]
    }

    for (let key in input) {
      inputs[currentPage - 1][key] = input[key]
    }
  })

  // eslint-disable-next-line array-callback-return
  comments.map(((comment, index) => {
    const schema = {}

    if (currentTextTop > PAGE_LIMIT - 54) {
      currentPage += 1
      currentTextTop = 20
    }
    
    currentTextTop += 4
    schema[`comment_title_${index}`] = {
      "type": "text",
      "position": {
        "x": 24,
        "y": currentTextTop,
      },
      "width": 60,
      "height": 12,
      "fontSize": 18,
      "fontColor": "#ef8303",
      "fontName": "coolveltica",
      "lineHeight": 1.4
    }

    currentTextTop += 5
    schema[`comment_box_${index}`] = {
      "type": "image",
      "position": {
        "x": 16,
        "y": currentTextTop
      },
      "width": 176,
      "height": 54
    }

    currentTextTop += 2
    schema[`comment_name_${index}`] = {
      "type": "text",
      "position": {
        "x": 24,
        "y": currentTextTop,
      },
      "width": 60,
      "height": 12,
      "fontSize": 22,
      "fontColor": "#102069",
      "fontName": "coolveltica",
      "lineHeight": 1.4
    }

    currentTextTop += 8
    schema[`comment_insitution_${index}`] = {
      "type": "text",
      "position": {
        "x": 24,
        "y": currentTextTop,
      },
      "width": 60,
      "height": 12,
      "fontSize": 18,
      "fontColor": "#102069",
      "fontName": "coolveltica_condensed",
      "lineHeight": 1.4
    }

    currentTextTop -= 3
    schema[`comment_date_${index}`] = {
      "type": "text",
      "position": {
        "x": 164,
        "y": currentTextTop,
      },
      "width": 20,
      "height": 8,
      "fontSize": 18,
      "fontColor": "#fff",
      "backgroundColor": "#102069",
      "fontName": "coolveltica_condensed",
      "lineHeight": 1,
      "alignment": "center",
    }

    currentTextTop += 12
    schema[`comment_message_${index}`] = {
      "type": "text",
      "position": {
        "x": 24,
        "y": currentTextTop,
      },
      "width": 160,
      "height": 30,
      "fontSize": 10,
      "fontName": "raleway",
      "lineHeight": 1.4,
      "fontColor": "#102069",
    }

    currentTextTop -= 23
    schema[`comment_message_icon_${index}`] = {
      "type": "image",
      "position": {
        "x": 185,
        "y": currentTextTop
      },
      "width": 10,
      "height": 10
    }

    if (inputs.length < currentPage) {
      inputs.push({})
    }

    currentTextTop += 58

    function formatDate(date) {
      if (!date) return '';
  
      const d = date.split('-'); // yyyy-mm-dd
      return `${d[2]}/${d[1]}/${d[0]}`
    }

    inputs[currentPage - 1][`comment_title_${index}`] = "Comentário"
    inputs[currentPage - 1][`comment_name_${index}`] = comment?.user || comment?.name || ''
    inputs[currentPage - 1][`comment_insitution_${index}`] = comment?.institution || ''
    inputs[currentPage - 1][`comment_date_${index}`] =  comment?.date? formatDate(comment?.date) : ''
    inputs[currentPage - 1][`comment_message_${index}`] = comment?.body || comment?.message || ''
    inputs[currentPage - 1][`comment_box_${index}`] = COMMENT_BOX_IMG
    inputs[currentPage - 1][`comment_message_icon_${index}`] = MESSAGE_ICON

    for (let key in schema) {
      template.schemas[0][key] = schema[key]
    }
  }))

  //console.log(inputs);
  //console.log("===================================");
  //console.log(template.schemas[0].art_line_03.width);

  const pdf = await generate({ template, inputs, options: { font } });

  const blob = new Blob([pdf.buffer], { type: 'application/pdf' });
  window.open(URL.createObjectURL(blob));
}